// extracted by mini-css-extract-plugin
export default {"form-button":"FormButton_form-button__qfCNm","disabled":"FormButton_disabled__2fAe-"};